/* eslint-disable camelcase */
import { authFetch } from "~/services/fetch";

interface getInterestPointSearchLogsProps {
    readonly action?: string | null;
    readonly userId?: number | null;
    readonly origin?: string | null;
    readonly device_id?: number | null;
    readonly station_id?: number| null;
    readonly startDate?: string | null;
    readonly finishDate?: string | null;
    readonly limit?: number;
    readonly page?: number;
    readonly sortField?: string;
    readonly sortOrder?: 'asc' | 'desc';
}

export async function getInterestPointSearchLogs({
    action,
    userId,
    startDate,
    finishDate,
    limit = 10000,
    page = 0,
    sortField,
    sortOrder,
    origin,
    device_id,
    station_id
}: getInterestPointSearchLogsProps) {
    const orders = sortField && sortOrder ? [{ field: sortField, sort: sortOrder }] : [{ "field": "created_at", "sort": "desc" }]
    const response = await authFetch({
        url: '/interest-point/log',
        method: 'POST',
        data: {
            action: action,
            user_id: userId,
            station_id: station_id,
            device_id: device_id,
            origin: origin,
            start_date: startDate,
            finish_date: finishDate,
            limit: limit,
            page: page,
            orders: orders
        }
    })

    return response.data
}